import styled from "@emotion/styled";

export const GenderContainer = styled.div`
    min-width: 110px;
    margin-right: 24px;
`;

export const GenderLabel = styled.p`
    margin: 16px 0 10px;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
`;
